import _sfc_main from "./component-library173.mjs";
import "./component-library174.mjs";
import normalizeComponent from "./component-library92.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.LinkButton, { staticClass: "energy-label-icon", attrs: { "aria-label": `Energieeffizienz ${_vm.energyClass}`, "tag": "button", "type": "button", "no-styling": "" }, on: { "click": function($event) {
    $event.stopPropagation();
    $event.preventDefault();
    return _setup.emitClick.apply(null, arguments);
  } } }, [_c(_setup.Icon, { attrs: { "energy-class": _vm.energyClass, "reverse": _vm.reverse } }), _vm._t("lightbox", null, { "title": _setup.title })], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "71894d48",
  null,
  null
);
const Icon = __component__.exports;
export {
  Icon as default
};
